import { env } from '../../../config/env';
import { encryptPayload } from './crypto';
import type { OrderContext } from '../types';

interface FinalPaymentData {
  authToken: string;
  db_ptr: string;
  amount: number;
  country: string;
  paymentSuccess: boolean;
  paymentID: string | null;
  paymentProvider: string;
  paymentRefId: string;
  paymentResult: { success: boolean; data: unknown };
}

/**
 * The one hop back into the booking app, same shape the old
 * IndiaPayment.js used (`paymentID`/`paymentSuccess`, not the camelCase
 * OrderContext fields) so the booking-status page — unchanged — keeps
 * reading what it already expects. `window.name` is kept as the documented
 * Chrome fallback; the URL param is what survives in every browser,
 * Firefox included, since it wipes `window.name` on a cross-site redirect.
 */
export function redirectToBookingStatus(
  order: OrderContext,
  outcome: {
    success: boolean;
    gatewayId: string;
    gatewayPaymentId: string | null;
    appointmentData?: unknown;
  }
): void {
  const finalPaymentData: FinalPaymentData = {
    authToken: order.authToken,
    db_ptr: order.dbPtr,
    amount: order.amount,
    country: order.country,
    paymentSuccess: outcome.success,
    paymentID: outcome.gatewayPaymentId,
    paymentProvider: outcome.gatewayId,
    paymentRefId: order.orderId,
    paymentResult: {
      success: outcome.success,
      data: outcome.appointmentData ?? null,
    },
  };

  const encrypted = encryptPayload(finalPaymentData);

  window.name = encrypted;
  window.location.href = `${env.VITE_PUBLIC_URL}/portal/booking-status?data=${encodeURIComponent(encrypted)}`;
}
